

export default {
  name: 'index',
  data() {
    return {
      source: [],
      loading: false,
      total: undefined,//总页数
      pageSize: 20,//每页显示条目个数
      currentPage: 1,//当前页

    };
  },
  mounted() {
    this.getMessageReplies()
  },

  methods: {
    async getMessageReplies(pageNo = 1) {
      //回复列表
      this.loading = true
      let res = await this.$global.messageReplies({ page: pageNo })
      if (res.code == 200) {
        res.data.noticeList.data.forEach((item, index) => {
          item.replyComment = ''
          item.replyOpen = false
        })
        this.source = res.data.noticeList.data
        this.loading = false
        this.total = parseInt(res.data.noticeList.total)
        let messageInfo = []
        for (let key in res.data.get_message) {
          messageInfo.push(res.data.get_message[key])
        }
        this.$store.commit('MESSAGEINFO', messageInfo)
      } else {
        this.$message.error(res.msg);
      }
    },
    handleCurrentChange(val) {
      //分页
      this.getMessageReplies(val)
    },
    async readInfo(item) {
      //已读
      if (Number(item?.is_reader) === 0) {
        const messageInfo = Array.isArray(this.$store.state.messageInfo) ? [...this.$store.state.messageInfo] : []
        if (typeof messageInfo[1] !== 'undefined') {
          messageInfo[1] = Math.max((Number(messageInfo[1]) || 0) - 1, 0)
          this.$store.commit('MESSAGEINFO', messageInfo)
        }
        item.is_reader = 1
      }
      this.$global.updateNotice({ id: item?.id })
      if(item?.worksInfo?.id){
        this.$router.push({ path: `/gallery/${item?.worksInfo?.id}` })
      }else if(item?.postsInfo?.id){
        this.$router.push({ path: `/discussion/${item?.postsInfo?.id}` })
      }
    },
    replyTo(item) {
      //input文案
      return this.$t('page.REPLY_TO_USER', { nickname: item.fromUserInfo.nickname })
    },
    async replyUser(item) {
      //回复用户
      // if (!item?.worksInfo?.id) {
      //   this.$message.error(this.$t('page.MESSAGE_DATA_INVALID'));
      //   return;
      // }
      let res = await this.$global.commentAdd({
        id: item?.worksInfo?.id || item?.postsInfo?.id, relationType: 1, content: item.replyComment, is_anonymous: 0, parent_id: item?.commentInfo?.id || 0, appoint_uid: "", reply_uid: item.from_uid, appoint_uid: "[]"
      })
      res.code == 200 ? (this.$message(this.$t('page.SUCCESS')), item.replyOpen = false, item.replyComment = '') : this.$message.error(this.$t('page.ERROR'));
    }


  }

}
